import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Text } from '@components/common';
import { connect } from 'react-redux';

import ScheduleBoard from '@components/ScheduleBoard';
import DragHandle from '@components/draggable/DraggableCalendarCell';
import DropContainer from '@components/draggable/DropContainer';
import BookingBoardHeader from './BookingBoardHeader';

import { BookingSelectors } from '@redux/BookingRedux';
import ScheduleActions, { ScheduleSelectors } from '@redux/ScheduleRedux';
import { DragSelectors, DRAG_ITEM_TYPES } from '@redux/DragRedux';

const BannerText = styled(Text)`
  border-radius: 0px 0px 4px 4px;
  padding: 4px;
  font-size: 12px;
`;

const DraggableWrapper = styled(Box)`
  position: relative;
`;

const DropContainerWrapper = styled(DropContainer)`
  width: 100%;
`;

function BookingBoardView(props) {
  const {
    selectedItems,
    numOfRows,
    blockedCols,
    removeItem,
    moveItem,
    showBanner,
    isRemovableDragging,
    property
  } = props;

  const specialItems = selectedItems.reduce((acc, item) => {
    const { row, col, serviceType, timeframe } = item;
    if (!acc[`row_${row}`]) {
      acc[`row_${row}`] = {};
    }
    acc[`row_${row}`][`col_${col}`] = {
      row,
      col,
      timeframe,
      serviceType
    };
    return acc;
  }, {});

  const handleOnDrop = (item, row, col) => {
    if (row === -1 || col === -1) {
      removeItem(item);
      return;
    }

    moveItem(item, {
      ...item,
      row,
      col
    });
  };

  const renderItem = (specialItem, disabled) => {
    const { serviceType } = specialItem;
    const icon = serviceType;

    return (
      <Box display="flex" flexDirection="column">
        <DragHandle
          icon={icon}
          disabled={disabled}
          dragType={DRAG_ITEM_TYPES.REMOVABLE}
          onDrop={(row, col) => handleOnDrop(specialItem, row, col)}
        />
      </Box>
    );
  };

  const renderHeader = () => {
    return <BookingBoardHeader property={property} title="My Schedule" />;
  };

  const renderFooter = () => {
    if (!showBanner) {
      return null;
    }
    return (
      <BannerText color="white" bg="primary" textAlign="center">
        Get 10% off when you spend $75 in a month
      </BannerText>
    );
  };

  return (
    <Box display="flex" flexDirection="column">
      <ScheduleBoard
        numOfRows={numOfRows}
        reservedCols={blockedCols}
        specialItems={specialItems}
        renderSpecialItem={renderItem}
        renderHeader={renderHeader}
        renderFooter={renderFooter}
      />
      <Box
        style={{ zIndex: isRemovableDragging ? -1 : 100 }}
        alignSelf="stretch"
        px={4}
      >
        <DraggableWrapper className="drag-remove-container">
          <DropContainerWrapper title="Drop here to remove cleans" />
        </DraggableWrapper>
      </Box>
    </Box>
  );
}

BookingBoardView.propTypes = {
  selectedItems: PropTypes.array,
  numOfRows: PropTypes.number,
  addRow: PropTypes.func,
  removeRow: PropTypes.func,
  moveItem: PropTypes.func,
  removeItem: PropTypes.func,
  showBanner: PropTypes.bool,
  blockedCols: PropTypes.array,
  isRemovableDragging: PropTypes.bool,
  property: PropTypes.object
};

const mapStatesToProps = state => ({
  selectedItems: ScheduleSelectors.selectScheduledItems(state),
  numOfRows: ScheduleSelectors.selectNumOfRows(state),
  blockedCols: ScheduleSelectors.selectBlockedDays(state),
  isRemovableDragging: DragSelectors.selectIsRemovableDragging(state),
  property: BookingSelectors.selectCurrentProperty(state)
});

const mapDispatchToProps = dispatch => ({
  addRow: () => dispatch(ScheduleActions.addScheduleBoardRow()),
  removeRow: () => dispatch(ScheduleActions.removeScheduleBoardRow()),
  removeItem: item => dispatch(ScheduleActions.removeSelectedItem(item)),
  moveItem: (item, newItem) =>
    dispatch(ScheduleActions.addRemoveSelectedItem(item, newItem))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(BookingBoardView);
